import React from 'react';
import clsx from 'clsx';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface RadioProps {
  className?: string;
  classNameRadioItem?: string;
  classNameRadioGroup?: string;
  onClick?: () => void;
  options: {
    id: string;
    value: string;
    label: React.ReactNode;
  }[];
  // controlled props
  value?: string;
  onValueChange?: (val: string) => void;
}

export const Radio: React.FC<RadioProps> = ({
  className = '',
  classNameRadioItem = '',
  classNameRadioGroup = '',
  options,
  value,
  onValueChange,
}) => {
  return (
    <div className={clsx('', className)}>
      <RadioGroup
        className={classNameRadioGroup}
        defaultValue={options[0]?.value}
        value={value}
        onValueChange={onValueChange}
      >
        {options.map((option) => (
          <div key={option.id} className="flex cursor-pointer items-center space-x-2">
            <RadioGroupItem className={classNameRadioItem} value={option.value} id={option.id} />
            <Label className="w-full cursor-pointer" htmlFor={option.id}>
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};
